<template>
  <div>
    <el-dialog ref="dialog" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="dialogVisible"
      :width="web ? '550px' : '100%'" class="logindialog">
      <!-- <div style="text-align: center;">
        <img style="margin: 0 auto;" src="../../assets/img/logo.png" alt="">
      </div> -->
      <div>
        <div class="account">Account</div>
        <el-form :model="user" ref="userForm" label-width="120px" label-position="left">
          <el-form-item label="Username" prop="name">
            <span class="con-lable">{{ userObj.email }}</span>
          </el-form-item>
          <el-form-item label="Uid" prop="uid">
            <el-tooltip class="item" effect="light" placement="top-start">
              <div slot="content" class="contentUid">Please keep your UID safe. If you forget your login password br and are also unable to
                receive verification codes at your registered email address, you can send your UID and account login
                email address to our customer service email address. Our customer service staff will assist you in
                resetting your account password.</div>
              <span class="item-tool">?</span>
            </el-tooltip>
            <span class="con-lable">{{ userObj.uid }}</span>
          </el-form-item>
          <el-form-item label="Age" prop="age">
            <el-input v-model="user.age" size="small" v-if="!disable" placeholder="Please enter age"></el-input>
            <span v-if="disable" class="con-lable">{{ userObj.age || '/' }}</span>
          </el-form-item>
          <el-form-item label="Gender" prop="gender">
            <el-select v-if="!disable" v-model="user.gender" size="small" placeholder="Please enter gender">
              <el-option v-for="item in ageOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <span v-if="disable" class="con-lable">{{ userObj.gender || '/' }}</span>
          </el-form-item>
          <el-form-item label="Bio" prop="bio">
            <el-input v-model="user.bio" v-if="!disable" size="small" placeholder="Please enter bio"></el-input>
            <span v-if="disable" class="con-lable">{{ userObj.bio || '/' }}</span>
          </el-form-item>
          <el-form-item label="Occupation" prop="occupation">
            <el-input v-model="user.occupation" v-if="!disable" size="small"
              placeholder="Please enter occupation"></el-input>
            <span v-if="disable" class="con-lable">{{ userObj.occupation || '/' }}</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <button type="button" class="btn3" v-if="disable" @click="putUser">EDIT</button>
        <button type="button" class="btn3" v-if="!disable" @click="putSave">SAVE</button>
        <button type="button" class="btn2" style="margin-left: 14px;" @click="logout">LOGOUT</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'accountDialog',
  data() {
    return {
      dialogVisible: false,
      disable: true,
      web: this.$utils.isDesktop(),
      loginTpye: 'login',
      ageOptions: [
        { value: 'Male', label: 'Male' },
        { value: 'Female', label: 'Female' }
      ],
      user: {
        name: '',
        email: '',
        uid: '',
        bio: '',
        age: '',
        gender: '',
        occupation: '',
        region: '',
        username: '',
        password: '',
        checked: [],
        userForm: {}
      },
    };
  },
  computed: {
    ...mapState({
      gameName1: state => state.user.gameName1,
      uid: state => state.user.uid,
      userObj: state => state.user.userObj,
    })
  },
  methods: {
    ...mapActions(['getUser']),
    show() {
      this.dialogVisible = true
    },
    hide() {
      this.dialogVisible = false
    },
    async logout() {
      await this.$api.login.logoutUser()
      sessionStorage.removeItem('game')
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('gameName')
      sessionStorage.removeItem('uid')
      this.$router.go()
    },
    async putSave() {
      try {
        let data = {
          age: this.user.age,
          gender: this.user.gender,
          occupation: this.user.occupation,
          bio: this.user.bio,
          region: '',
          username: '',
        }
        let res = await this.$api.login.putUserProfile(data)
        if (res) {
          this.$store.commit('userObjFun', res.data)
          this.user.age = res.data.age
          console.log(this.user, res.data.age);

          this.disable = true
        }
      } catch { }
    },
    async putUser() {
      this.disable = false
      this.user = this.userObj
    },
  },
  mounted() {
    if (sessionStorage.getItem('gameName')) {
      this.getUser()
    }
  }
}
</script>

<style lang="less" scoped>
.logindialog {
  padding: 0px 10px;
}

.retrieve {
  border-bottom: 1px solid #4b98ea;
}

.con-lable {
  font-size: 16px;
}

.account {
  border-bottom: 1px solid #ccc;
  font-size: 20px;
  margin-bottom: 16px;
}

.btn2 {
  background: rgb(211 68 60);
  border-radius: 12px;
}

.btn3 {
  background: #409eff;
  border-radius: 12px;
}

.contentUid {
  width: 500px;
}
.item-tool {
  font-weight: bold;
  font-size: 16px;
  position: absolute;
  left: -20%;
  cursor: pointer;
}

/deep/.el-dialog {
  border-radius: 16px;
}

/deep/.el-dialog__headerbtn {
  font-size: 20px;
  top: 10px;
  right: 18px;
}

/deep/.el-dialog__body {
  padding: 0px 30px 12px;
}

/deep/.el-form-item {
  margin-bottom: 8px;
}

/deep/.el-form-item__label {
  font-size: 18px;
}
</style>